<template>
  
    <div class="row appt-type">

      <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1">
        <hr class="hr-salmon">
        <h2>Confirm Encounter Type</h2>

        <p v-if="!appointment">No appointment found, please go back and select one.</p>

        <encounter-preview-box v-if="appointment && activeEncounterType" :appointment="appointment" :encounter="activeEncounterType" />

        <div v-if="validEncounterTypes && validEncounterTypes.length">
          <h5><strong>Edit Encounter Type</strong></h5>
          <select
            v-model="activeEncounterType"
            class="form-control"
            @change="clearActiveTP"
          >
            <!-- disable placeholder option to default to only option, until other types added later -->
            <!-- <option disabled :value="null">select one</option> -->
            <option v-for="eType in validEncounterTypes" :value="eType">{{ eType.name }}</option>
          </select>
        </div>

        <div v-if="activeEncounterType && activeEncounterType.encounter_type=='tpPresentation'">
          <h5><strong>Select Treatment Plan</strong> <small>required</small></h5>
          <p class="loading" v-if="loadingTPs"><i class="far fa-fw fa-pulse fa-spinner"></i></p>
          <select
            v-if="!loadingTPs && treatPlans"
            v-model="activeTreatmentPlan"
            class="form-control"
          >
            <option disabled :value="null">select one</option>
            <option v-for="tp in treatPlans" :value="tp" :key="tp.TreatPlanNum">{{ tp.Heading }} ({{ tp.SecDateTEdit | prettyDateShortFromDT }})</option>
          </select>
        </div>

        <div>
          <!-- <p class="text-right" v-if="encounterAlreadySaved && savedAptStatus">
            <em v-if="savedAptStatus=='started'">setup started</em>
            <em v-if="savedAptStatus=='inProgress'">setup in progress</em>
            <em v-if="savedAptStatus=='complete'"><i class="fas fa-check color-green"></i> setup complete</em>
            <em v-if="savedAptStatus=='aptComplete'"><i class="fas fa-check color-green"></i> appointment complete</em>
          </p> -->
          <p class="text-right">
            <button :disabled="!passedValidation" @click.prevent="saveEncounterType" class="btn btn-green btn-lg">Begin Slides<i class="fas fa-angle-right fa-fw"></i></button>
          </p>
        </div>
      </div> <!-- /.col -->
    
    </div> <!-- /.row -->
  
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
import EncounterPreviewBox from '../components/EncounterPreviewBox.vue'
import moment from 'moment-timezone';

export default {
  props: ['customer'],
  components: {
    ListErrors, EncounterPreviewBox,
  },
  data() {
    return {
      validEncounterTypes: [
        {
          encounter_type: 'tpPresentation',
          name: 'Treatment Plan Presentation',
        },
      ],
      activeEncounterType: null,
      treatPlans: null,
      activeTreatmentPlan: null,
      patNum: null,
      procedureLogs: null,
      loadingTPs: false,
      errors: [],
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter']),
    // encounterAlreadySaved() {
    //   if(this.savedAppointmentEncounters && Object.keys(this.savedAppointmentEncounters).length && this.savedAppointmentEncounters[`${this.appointment.AptNum}_${this.activeEncounterType.encounter_type}`] && (!this.activeTreatmentPlan || this.activeTreatmentPlan.TreatPlanNum == this.savedAppointmentEncounters[`${this.appointment.AptNum}_${this.activeEncounterType.encounter_type}`].treat_plan_num)) {
    //     return true;
    //   }
    //   return false;
    // },
    // savedAptStatus() {
    //   if(this.encounterAlreadySaved) {
    //     return this.savedAppointmentEncounters[`${this.appointment.AptNum}_${this.activeEncounterType.encounter_type}`].encounter_setup_status;
    //   }
    //   return null;
    // },
    passedValidation() {
      // validate valid encounter type
      if(this.activeEncounterType && this.validEncounterTypes.includes(this.activeEncounterType)) {
        // console.log('Valid encounter type selected:', this.activeEncounterType);
        // validate type tpPresentation
        if(this.activeEncounterType.encounter_type == 'tpPresentation') {
          // console.log('Validating for encounter type: tpPresentation');
          // has active treatment plan selected
          if(this.activeTreatmentPlan && this.treatPlans && this.treatPlans.find(tp => tp.TreatPlanNum == this.activeTreatmentPlan.TreatPlanNum)) {
            // console.log('met requirements for tpPresentation');
            return true;
          }
        }
        // validate next encounter type here
      }
      return false;
    },
    aptDateStamp() {
      // store datestamp to use looking up encoutner in firestore
      if(this.appointment && this.appointment.AptDateTime) {
        return moment.tz(this.appointment.AptDateTime, 'America/Chicago').format("YYYYMMDD");
      }
      return null;
    },
  },
  watch: {
    // process active appointment
    appointment(newVal, oldVal) {
      if(newVal) {
        if(newVal.PatNum) {
          // set patnum when appointment changes
          this.patNum = newVal.PatNum;
          // TODO: later: load ProcedureLogs for the appointment, save in this.procedureLogs
          this.procedureLogs = true; // placeholder to trigger encounter type logic
        }
        // // store patient name so don't have to load it again later during encounter
        // if(newVal.PatientName) {
        //   this.$store.dispatch('updatePatName', this.appointment.PatientName);
        // }
        // // load all saved encounters for this AptNum
        // this.loadAptEncounters()
      }
    },
    // load treatment plans when encounter type is tpPresentation
    activeEncounterType(newVal, oldVal) {
      if(newVal && newVal !== oldVal && newVal.encounter_type == 'tpPresentation') {
        this.loadPlansByPatNum();
      }
    },
    // recommend encounter type when procedureLogs load
    procedureLogs(newVal, oldVal) {
      if(newVal) {
        // TODO: later: recommend encounter type based on attached procedures
        this.activeEncounterType = this.validEncounterTypes[0]; // placeholder until we load procedureLogs later
      }
    },
  },
  methods: {
    clearActiveTP() {
      if(this.activeEncounterType && this.activeEncounterType.encounter_type != 'tpPresentation') {
        this.activeTreatmentPlan = null;
      }
    },
    async saveEncounterType() {
      // validate requirements
      if(!this.passedValidation) {
        console.log('missing requirements to save encounter type');
        return;
      }
      // exit if missing data
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location) {
        console.log('missing permissions to save appointment encounter type');
        return;
      }
      let encounterObject;
      
      // if already saved and options match, continue it
      if(this.encounter && this.encounter.encounter_type) {
        console.log('encounter already saved, continuing it');
      } else {
        // console.log('saving new encounter for setup');
        // if not already saved, save it
        // create firestore object & key
        encounterObject = {
          ...this.encounter,
          // encounter_id : `${this.appointment.AptNum}_${this.aptDateStamp}_condensed`,
          encounter_type: this.activeEncounterType.encounter_type,
          // appointment_num: this.appointment.AptNum,
          // encounter_setup_status: 'started',
          // datestamp: this.aptDateStamp,
          // timestamp: moment.tz(this.appointment.AptDateTime, 'America/Chicago').unix(),
          // TODO: ? save last updated timestamp - for follow-up tasks
          // TODO: ? save last updated datestamp - for follow-up tasks
          // pat_num: this.patNum, // do not store in databse unless absolutely necessary
        };
        const encounterId = `${this.appointment.AptNum}_${this.aptDateStamp}_condensed`;
        // include treatPlanNum if tpPresentation type
        if(this.activeEncounterType.encounter_type == 'tpPresentation') {
          encounterObject.treat_plan_num = this.activeTreatmentPlan.TreatPlanNum;
        }
        // save in firestore
          // save in /customers/{customerId}/locations/{locationId}/encounters/{encounterId}
        let encounterRef = Vue.firestore.doc(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/encounters/${encounterId}`);
        try {
          let encounterSaved = await encounterRef.set(encounterObject);
          // console.log('saved encounter');
          // save encounter data in store
          this.$store.dispatch('updateEncounter',encounterObject);
          // save TreatPlan in store
          this.$store.dispatch('updateTreatmentPlan', this.activeTreatmentPlan);
        } catch(err) {
          console.error('Failed to save encounter for setup:', err);
          return;
        }
      }
      // navigate to next slide is called in SlidesModal when encounter changes and an encounter_type detected
      // this.$emit('forward');
    },
    // clearSelectedAppointment() {
    //   this.$store.dispatch('clearAppointment');
    //   this.$store.dispatch('clearPatNum');
    //   this.$store.dispatch('clearPatName');
    //   this.$store.dispatch('clearTreatmentPlan');
    //   this.$router.push({ name: 'appointmentSelect' });
    // },
    loadPlansByPatNum() {
      this.loadingTPs = true;
      this.errors = [];
      // validate patNum
      if(!this.patNum || !this.patNum.toString().length > 10 || !Number.isInteger(this.patNum)) {
        this.errors.push("Invalid Patient Number (PatNum)");
      }
      // validate required data exists
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        this.errors.push("You're missing the permissions to load treatment plans. Please contact a team lead.");
      }
      if(this.errors.length) {
        this.loadingTPs = false;
        return;
      }
      this.treatPlans = [];
      // use callable function
      var loadPlansByPatNumFunc = Vue.functions.httpsCallable('loadPlansByPatNum');
      loadPlansByPatNumFunc({
        patNum: this.patNum,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('loadPlansByPatNum result',result);
          this.loadingTPs = false;
          if(result && result.data && result.data.length) {
            this.treatPlans = result.data;
          } else {
            this.errors.push("No treatment plans with the status 'saved' found for that Patient Number in Open Dental");
          }
        })
        .catch(err => {
          this.errors.push(err.message)
          this.loadingTPs = false;
          console.log(err);
        });
    },
  },
  mounted() {
    if(this.appointment) {
      if(this.appointment.PatNum) {
        this.patNum = this.appointment.PatNum;
        // TODO: later: load ProcedureLogs for the appointment, save in this.procedureLogs
        this.procedureLogs = true; // placeholder to trigger encounter type logic
      }
      // // store patient name so don't have to load it again later during encounter
      // if(this.appointment.PatientName) {
      //   this.$store.dispatch('updatePatName', this.appointment.PatientName);
      // }
      // // load all saved encounters for this AptNum
      // this.loadAptEncounters();
    }
  },
  
};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.appt-type {
  padding-top: 55px;
  padding-bottom: 30px;
}
.hr-salmon {
  margin-top: 0;
}

</style>
